// FUNNEL VUEX STATE
export default {
   cart: {
      couponCode: null,
      country: '',
      currency: '',
      deliveryDate: '',
      email: null,
      gatewayId: null,
      isBusinessCustomer: false,
      language: '',
      number: '',
      numberOfPeople: 0,
      occasion: '',
      relatedSite: '',
      shippingMethod: { name: null, handle: null },
      shortNumber: '',
      specialWishes: null,
   },
   menu: {
      courses: [],
      id: null, // product ID
      isALaCarte: false,
      isShippable: false,
      items: {},
      minimumOrderValue: 0,
      sectionIndex: 0,
      sections: [],
      title: '',
      variantId: null,
   },

   // the MenuItem.vue component that has been clicked on to view more details.
   focusedMenuItem: null,

   // a list of all MenuItems that are visible on the page, organized into arrays corresponding
   // to their dish/drink/accessory category slug.
   visibleMenuItems: {},

   summary: {
      adjustments: {
         discount: [],
         shipping: [],
      },
      courseItems: {},
      lineItems: {
         accessories: {},
         dishes: {},
         drinks: {},
         menus: null,
      },
      lineItemsFlattened: [],
      showNetAmounts: false,
      tax: {
         total: 0,
         food: {
            title: 'VAT',
            total: 0,
            rate: null,
            percentage: null,
         },
         nonFood: {
            title: 'VAT',
            total: 0,
            rate: null,
            percentage: null,
         },
      },
      total: {gross: 0, net: 0},
   },

   isCartDataLoaded: false
}